import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import {
    BaasicTable,
    TableFilter,
    EmptyState,
    BaasicButton,
    BaasicModal
} from "core/components";
import { isSome } from "core/utils";
import { ApplicationListLayout, Content } from "core/layouts";
import { toDate } from 'core/utils';
import { BackOrderEditModal } from "application/pick-ticket/components";
import { DropDownButton, DropDownButtonItem } from "@progress/kendo-react-buttons";
import { PickTicketInfoModal } from "application/pick-ticket-new-flow/components";

const PickTicketDetailListTemplate = function ({ pickTicketDetailListViewStore }) {

    const {
        tableStore,
        routes,
        queryUtility,
        authorization,
        pickTicketHeader,
        deliveryDate,
        backOrderEditModal,
        downloadPickTicket,
        sendOrder,
        refresh,
        openPickTicketInfoModal,
        pickTicketInfoModal
    } = pickTicketDetailListViewStore;

    const facilityName = pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.name;
    const facilityAddress = pickTicketHeader && pickTicketHeader.facilityOrders[0].facility.address;
    const dateOfService = pickTicketHeader && toDate(pickTicketHeader.facilityOrders[0].dateOfService);
    const dateOfDelivery = deliveryDate && toDate(deliveryDate);
    const dateCreated = pickTicketHeader && toDate(pickTicketHeader.facilityOrders[0].dateCreated, true);
    const pickTicketNo = pickTicketHeader && `${pickTicketHeader.pickTicketNo}-${pickTicketHeader.pickTicketNoSerial}`;
    const isPickTicketHeaderStatusNew = pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.abrv === 'new';
    return (
        <React.Fragment>
            <div className="header-custom">
                <div className="row u-flex--space-between">
                    <div className="col col-lrg-4">
                        <div>
                            <h2>{pickTicketNo}</h2>
                            <div>
                                <span className="u-mar--right--tny">{facilityName}</span>
                            </div>
                            <div>
                                <span className="u-mar--right--tny">{facilityAddress}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col col-lrg-3">
                        <div>
                            <span>Date Created: <strong>{dateCreated}</strong></span>
                        </div>
                        <div>
                            <span>Status: <strong>{pickTicketHeader && pickTicketHeader.pickTicketHeaderStatus && pickTicketHeader.pickTicketHeaderStatus.name}</strong></span>
                        </div>
                    </div>
                    <div className="col col-lrg-2">
                        <div>
                            <span>Date of Service: <strong>{dateOfService}</strong></span>
                        </div>
                        <div>
                            <span>Delivery Date: <strong>{dateOfDelivery}</strong></span>
                        </div>
                    </div>
                    <div className="col col-lrg-3">
                        <div className="u-push">
                            <DropDownButton
                                fillMode={"solid"}
                                themeColor={"primary"}
                                text="Download"
                                onItemClick={(e) => downloadPickTicket(e.item.text)}
                                buttonClass="btn btn--base btn--light"
                                popupSettings={{
                                    animate: false,
                                    anchorAlign: { horizontal: "left", vertical: "bottom" },
                                    popupAlign: { horizontal: "left", vertical: "top" },
                                    popupClass: 'is-clean'
                                }}
                            >
                                <DropDownButtonItem text="PDF" />
                                <DropDownButtonItem text="XLSX" />
                            </DropDownButton>
                        </div>
                        <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Send Order'} onClick={() => sendOrder()}></BaasicButton>
                        {isPickTicketHeaderStatusNew && <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Refresh'} onClick={() => refresh()}></BaasicButton>}
                        <BaasicButton className="btn btn--base btn--primary u-mar--right--tny u-push" label={'Info'} onClick={() => openPickTicketInfoModal()}></BaasicButton>
                    </div>
                </div>
            </div>
            <ApplicationListLayout
                store={pickTicketDetailListViewStore}
                authorization={authorization}
            >
                <Content emptyRenderer={renderEmpty(routes)}>
                    <div className="u-mar--bottom--sml">
                        <TableFilter queryUtility={queryUtility} showSearchFilter={false} filterVisible={true}>
                        </TableFilter>
                    </div>
                    <div className="card--table">
                        <BaasicTable
                            authorization={authorization}
                            tableStore={tableStore}
                            actionsComponent={renderActions}
                        />
                    </div>
                    <BaasicModal modalParams={backOrderEditModal} className="modal__content modal--sml">
                        <BackOrderEditModal />
                    </BaasicModal>
                </Content>
            </ApplicationListLayout>
            <BaasicModal modalParams={pickTicketInfoModal} className="modal__content modal--xlrg">
                <PickTicketInfoModal />
            </BaasicModal>
        </React.Fragment>

    );
};

function renderEmpty() {
    return (
        <EmptyState
            title="PICK_TICKET_DETAIL.LIST.EMPTY_STATE.TITLE"
        />
    );
}

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const {
        onEdit
    } = actions;
    if (
        !isSome(onEdit)
    )
        return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={
                            authorization ? authorization.update : null
                        }
                        className="btn btn--icon"
                        icon="u-icon u-icon--edit u-icon--sml"
                        label="PICK_TICKET_DETAIL.LIST.BUTTON.UPDATE_BACK_ORDER"
                        onlyIcon={true}
                        onClick={() => onEdit(item)}
                    ></BaasicButton>
                ) : null}
            </div>
        </td>
    );
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
}

PickTicketDetailListTemplate.propTypes = {
    pickTicketDetailListViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(PickTicketDetailListTemplate);